import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://api.rmtlotto.com/api',
  baseURL: 'https://api.hapi-lot.com/api/',
  // baseURL: 'http://127.0.0.1:9999/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
